import { cn } from '@/lib/utils'

export interface MeterPart {
  label: string
  value: number
  /** Class tô màu cho đoạn (ví dụ 'bg-toneFg', 'bg-toneFg/30'). */
  barClass: string
}

/**
 * Thanh chia phần, ví dụ "Đã trả / Chờ trả". Hai đoạn cách nhau 2px, mỗi
 * đoạn có dòng chú thích bằng chữ bên dưới nên đọc được cả khi không phân
 * biệt màu. Tổng bằng 0 thì chỉ hiện rãnh trống.
 */
export function SplitMeter({
  parts,
  format,
  className,
  textClass = 'text-inkSoft',
}: {
  parts: MeterPart[]
  format: (n: number) => string
  className?: string
  /** Màu chữ chú thích; trong ô pastel dùng màu chữ của tông. */
  textClass?: string
}) {
  const total = parts.reduce((s, p) => s + Math.max(0, p.value), 0)
  return (
    <div className={className}>
      <div
        className="flex h-2 gap-[2px] overflow-hidden rounded-full bg-raise/70"
        role="img"
        aria-label={parts.map((p) => `${p.label} ${format(p.value)}`).join(', ')}
      >
        {total > 0 &&
          parts.map((p) =>
            p.value > 0 ? (
              <span
                key={p.label}
                className={cn('h-full min-w-[4px] first:rounded-l-full last:rounded-r-full', p.barClass)}
                style={{ flexGrow: p.value, flexBasis: 0 }}
              />
            ) : null,
          )}
      </div>
      <div className={cn('mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs', textClass)}>
        {parts.map((p) => (
          <span key={p.label} className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <span className={cn('size-2 rounded-full', p.barClass)} aria-hidden />
            {p.label} <b className="font-semibold">{format(p.value)}</b>
          </span>
        ))}
      </div>
    </div>
  )
}
